import { VideoDemo } from '@/features/new-landing-page/pages/video-demo';

export default VideoDemo;
